/**
 * Centralized analytics event definitions
 * Format: [feature]_[action]_[target]
 */
export const ANALYTICS_EVENTS = {
  // Booking flow events
  BOOKING_START: 'booking_start',
  BOOKING_SELECT_DINERS: 'booking_select_diners',
  BOOKING_SELECT_DATE: 'booking_select_date',
  BOOKING_SELECT_SERVICE: 'booking_select_service',
  BOOKING_SELECT_MENU_FILTER: 'booking_select_menu_filter',
  BOOKING_SELECT_AREA_FILTER: 'booking_select_area_filter',
  BOOKING_SELECT_EXPERIENCE: 'booking_select_experience',
  BOOKING_SELECT_AREA: 'booking_select_area',
  BOOKING_SELECT_TIME: 'booking_select_time',
  BOOKING_MARIDAJE: 'booking_maridaje',
  BOOKING_PERSONALIZE: 'booking_personalize',
  BOOKING_PAYMENT: 'booking_payment',
  BOOKING_CONFIRM: 'booking_confirm',
  /**
   * User clicked the commit button on whichever step hosts the commit action.
   * Today: only the Confirm step. Post-flag-flip: Guarantee or Personalize.
   * Carries `source_step` so the same metric measures both funnels.
   * See docs/plans/preflight/conversion-telemetry-baseline.md for the dashboard query.
   */
  BOOKING_COMMIT_ATTEMPT: 'booking_commit_attempt',
  /**
   * Commit failed (CommitError). Carries `source_step`, `error_category`, and
   * `error_code` so the dashboard can break failures down by which step hosted
   * the click and what went wrong.
   */
  BOOKING_COMMIT_FAILURE: 'booking_commit_failure',
  BOOKING_COMPLETE: 'booking_complete',

  // Waiting list events
  BOOKING_WL_FORM: 'booking_wl_form',
  BOOKING_WL_CALENDAR: 'booking_wl_calendar',
  BOOKING_WL_ALTERNATIVES: 'booking_wl_alternatives',

  // Auth events
  AUTH_SIGN_IN: 'auth_sign_in',
  AUTH_SIGN_UP: 'auth_sign_up',
  AUTH_LOGIN_SUCCESS: 'auth_login_success',
  AUTH_SIGNUP_SUCCESS: 'auth_signup_success',
  AUTH_COMPLETE_PROFILE: 'auth_complete_profile',

  // Navigation events
  NAV_HOME: 'nav_home',
  NAV_PROFILE: 'nav_profile',
  NAV_CONTACT: 'nav_contact',

  // Gift card events
  GIFT_CARD_PURCHASE: 'gift_card_purchase',

  // Error events
  ERROR_API: 'error_api',
  ERROR_PAYMENT: 'error_payment',
  ERROR_VALIDATION: 'error_validation',
  ERROR_UNKNOWN: 'error_unknown',
} as const;

export type AnalyticsEventName = typeof ANALYTICS_EVENTS[keyof typeof ANALYTICS_EVENTS];
